import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import { Link as GatsbyLink } from 'gatsby';

import Theme from '@root/joinroot.com/src/components/brand/theme';
import { Colors, StyleSheet } from '@root/core/src/utils/styles';

function NavLink({
  children, to, linkStyles,
}) {
  const internal = false;

  if (internal) {
    return (
      <GatsbyLink
        css={styles.link}
        to={to}
      >
        {children}
      </GatsbyLink>
    );
  }

  return (
    <a
      css={[styles.link, linkStyles]}
      href={to}
    >
      {children}
    </a>
  );
}

const styles = StyleSheet.create({
  link: {
    ...Theme.navLink(),
    textDecoration: 'none',
    transition: 'color 0.1s cubic-bezier(0.455, 0.03, 0.515, 0.955)',
    '&:hover': {
      color: Colors.rootOrange(),
    },
    '&:focus': {
      color: Colors.rootOrange(),
    },
  },
});

NavLink.defaultProps = {
  component: 'a',
};

NavLink.propTypes = {
  children: PropTypes.string.isRequired,
  linkStyles: PropTypes.object,
  to: PropTypes.string.isRequired,
};

export default NavLink;
